import { getUserQueryOptions } from 'lib/auth';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';
import { http, HttpResponse, delay } from 'msw';

import { api } from 'lib/api-client';
import { MutationConfig } from 'lib/react-query';
import { env } from 'config/env';

export const acceptLegalDocumentsSchema = z.object({
    terms_of_service_version: z.string(),
    privacy_policy_version: z.string(),
});

export type AcceptLegalDocumentsInput = z.infer<
    typeof acceptLegalDocumentsSchema
>;

export const acceptLegalDocuments = async (
    data: AcceptLegalDocumentsInput,
): Promise<void> => {
    await api.post('/app/api/v1/legal_document_acceptance', data);
};

type UseAcceptLegalDocumentsOptions = {
    mutationConfig?: MutationConfig<typeof acceptLegalDocuments>;
};

export const useAcceptLegalDocuments = ({
    mutationConfig,
}: UseAcceptLegalDocumentsOptions = {}) => {
    const queryClient = useQueryClient();

    const { onSuccess, ...restConfig } = mutationConfig || {};
    return useMutation({
        ...mutationConfig,
        mutationFn: acceptLegalDocuments,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries(getUserQueryOptions());
            onSuccess?.(data, variables, context);
        },
        ...restConfig,
    });
};

export const acceptLegalDocumentsMSWHandler = (
    status = 204,
    duration?: number,
) => {
    return http.post(
        `${env.API_URL}/app/api/v1/legal_document_acceptance`,
        async () => {
            await delay(duration);
            if (status >= 400) {
                return new HttpResponse(null, { status });
            }
            return new HttpResponse(null, { status });
        },
    );
};
